export class Guest {
  constructor(
    public userId: number,
    public username: string,
    public uuid: string
  ) {}
}
